export interface UserInfo {
  active: boolean;
  createdBy: string;
  createdOn: number;
  pdtUsrPerms?: OrgUserRoles;
  orgId?: string;
  subOrg?: string;
  userRole?: string;
  emailId: string;
  emailVerified: string;
  id: string;
  lastModifiedBy?: string;
  lastModifiedOn?: number;
  nameFirst: string;
  nameLast: string;
  profilePic?: string;
}

interface OrgUserRoles {
  role: string;
  productId?: string;
}

export type UserRoles =
  | "SuperAdmin"
  | "Admin"
  | "Executive"
  | "Manager"
  | "Member";
export const ROLE_USER_SUPERADMIN = "SuperAdmin";
export const ROLE_USER_ADMIN = "Admin";
export const ROLE_USER_EXECUTIVE = "Executive";
export const ROLE_USER_MANAGER = "Manager";
export const ROLE_USER_MEMBER = "Member";
export const ROLE_USER_ORGUSERS = "OrgUsers";
export const ROLE_USER_OTHERUSERS = "OtherUsers";
export const ROLE_USER_ALL = "All";
